import { render, staticRenderFns } from "./ManageGeneral.vue?vue&type=template&id=503066d7&scoped=true&lang=pug&"
import script from "./ManageGeneral.vue?vue&type=script&lang=js&"
export * from "./ManageGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503066d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
